import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { BRAND } from '../generated/brand';

export default function Copyright(props: any) {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2.5,
        px: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        backgroundColor: '#ffffff',
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
        {...props}
      >
        {'Copyright © '}
        <Link color="inherit" href="#">
          {BRAND.legalName}
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    </Box>
  );
}
